'use strict';

/* Route Controller */

angular.module('storyApp').controller('RouteCtrl',['$scope', '$rootScope', '$location', '$window', '$timeout', 'storyInView', 'storyScroll', 'storyEvents', 
function($scope, $rootScope, $location, $window, $timeout, storyInView, storyScroll, storyEvents) {
  
    
    //bypass original url with no state
    if ($location.state() === null) {
        window.history.back();
    } else {

        var storyIndex = $location.state().storyIndex;

        //console.log("change url state to", storyIndex);
        
        //check first if we need to change index
        if(storyIndex !== -1 && storyIndex !== storyInView.getCurrentIndex()){
            //scroll to view
            storyInView.currentIndex = storyIndex;
            
            var elId = 'story-' + (storyIndex + 1);
            //console.log("jump to - ",elId);
            
            storyScroll.jumpToElement(elId, 0, false);
            
        }
    }

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/controllers/routeCtrl.js